import { render, staticRenderFns } from "./SaleBadGoods.vue?vue&type=template&id=7b8e665a&scoped=true"
import script from "./SaleBadGoods.vue?vue&type=script&lang=js"
export * from "./SaleBadGoods.vue?vue&type=script&lang=js"
import style0 from "./SaleBadGoods.vue?vue&type=style&index=0&id=7b8e665a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8e665a",
  null
  
)

export default component.exports